import { api } from './api';
import { ZoneAiAnalysis } from 'entities/common';
import { IRecognizeSensor, IRecognizeAppKey } from 'entities/view/sensorDetails';

const basePath = '/api/v1/sensors';

export const recognizeSensor = (file: File) => {
  const formData = new FormData();

  formData.append('file', file);

  return api.post<IRecognizeSensor>(`${basePath}/recognize-id`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const recognizeSensorAppKey = (file: File) => {
  const formData = new FormData();

  formData.append('file', file);

  return api.post<IRecognizeAppKey>(`${basePath}/recognize-appkey`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const getUserSensors = ({ user_id, query = '' }: { user_id: number; query?: string }) =>
  api.get(`/api/v1/users/${user_id}/sensors${query}`);

export const getUserMetrics = ({ user_id, query = '' }: { user_id: number; query?: string }) =>
  api.get(`/api/v1/users/${user_id}/metrics${query}`);

export const getSensorMetrics = ({
  query = '',
  sensor_id,
}: {
  sensor_id: number;
  query?: string;
}) => api.get(`${basePath}/${sensor_id}/metrics${query}`);

export const getSensorFullChart = ({
  sensor_id,
  query = '',
}: {
  sensor_id: number;
  query?: string;
}) => api.get(`${basePath}/${sensor_id}/metrics/full-chart${query}`);

export const getSensorChart = ({
  sensor_id,
  measurement_id,
  query = '',
}: {
  sensor_id: number;
  measurement_id: number;
  query?: string;
}) =>
  api.get(`${basePath}/${sensor_id}/metrics/${measurement_id}/chart${query}`);
export const getDeviceInfo = (eui: string) =>
  api.get(`${basePath}/device-info/${eui}`);

export const getZoneById = (zoneId: number) =>
  api.get(`/api/v1/zones/${zoneId}`, { skipRedirects: true } as any);

export const getZoneSensors = (zoneId: number) =>
  api.get(`/api/v1/zones/${zoneId}/sensors`);

export const getObjectSensors = (objectId: number) =>
  api.get(`/api/v1/objects/${objectId}/sensors`);

export const getObjectById = (objectId: number) =>
  api.get(`/api/v1/objects/${objectId}`);

export const getFilePresignedUrl = (fileId: string) =>
  api.get<{ url: string; expires_in: number }>(`/api/v1/files/${fileId}/url`, { skipRedirects: true } as any);

export const getZoneAiAnalysisLatest = (zoneId: number) =>
  api.get<ZoneAiAnalysis>(`/api/v1/zones/${zoneId}/ai-analysis/latest`, { skipRedirects: true } as any);

export const getZoneAiAnalysisDay = (zoneId: number, query: string = '') =>
  api.get(`/api/v1/zones/${zoneId}/ai-analysis/day${query}`, { skipRedirects: true } as any);
